export const TRANSLATION_GROUP_PREFIX = 'Agent: Testing chat: Step tokens:';

export const MAIN_CLASS_NAME = 'usage-tokens';
export const VALUE_CLASS_NAME = `${MAIN_CLASS_NAME}__value`;
export const GENERATIONS_CLASS_NAME = `${MAIN_CLASS_NAME}__generations`;
